/**
 * How store admin should respond when billing is required.
 * - ok: no billing friction
 * - soft: allow setup; show reminder CTA (pending card mandate)
 * - hard: lock the app (expired / past due)
 */
export type BillingAccessMode = 'ok' | 'soft' | 'hard'

export function resolveBillingAccessMode(opts: {
  billingRequired?: boolean | null
  subscriptionStatus?: string | null
}): BillingAccessMode {
  if (!opts.billingRequired) return 'ok'
  const status = String(opts.subscriptionStatus ?? '')
    .trim()
    .toLowerCase()
  if (status === 'expired' || status === 'past_due') return 'hard'
  return 'soft'
}
